/**
 * Shared-chronometer media clock on the client.
 * Prefer server sequenceStartTime / media_sync_at over per-device tick drift.
 */

export function mediaEpochMs(value) {
  if (value == null || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value) && value > 0) {
    return value;
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.getTime();
  }
  const n = Number(value);
  if (Number.isFinite(n) && n > 1e11) return n;
  const parsed = Date.parse(String(value));
  return Number.isFinite(parsed) ? parsed : null;
}

export function remainingSecFromWallClock(startMs, durationSec, nowMs = Date.now()) {
  const start = mediaEpochMs(startMs);
  const duration = Number(durationSec);
  if (!(start > 0) || !Number.isFinite(duration) || duration <= 0) return null;
  return Math.max(0, duration - Math.floor((nowMs - start) / 1000));
}

export function patchExerciseMediaClock(ex, payload) {
  if (!ex) return ex;
  if (!payload) return ex;
  const sequenceStartTime =
    payload.sequenceStartTime != null
      ? mediaEpochMs(payload.sequenceStartTime)
      : undefined;
  const synchronizedStartTime =
    payload.synchronizedStartTime != null
      ? mediaEpochMs(payload.synchronizedStartTime)
      : undefined;
  const mediaSyncAt =
    payload.media_sync_at != null || payload.mediaSyncAt != null
      ? mediaEpochMs(payload.media_sync_at ?? payload.mediaSyncAt)
      : undefined;
  return {
    ...ex,
    sequenceStartTime:
      sequenceStartTime != null ? sequenceStartTime : ex.sequenceStartTime,
    synchronizedStartTime:
      synchronizedStartTime != null
        ? synchronizedStartTime
        : ex.synchronizedStartTime,
    media_sync_at: mediaSyncAt != null ? mediaSyncAt : ex.media_sync_at,
  };
}
